import { cn } from '@app/utils/cn';
import { useTranslation } from 'react-i18next';

import { WarningOutline } from '../Icons';
import { Tooltip } from '../Tooltip';

interface Props {
  className?: string;
}

export const DelwinExpiredTooltip = ({ className }: Props) => {
  const { t } = useTranslation(['expiredDelwins']);

  return (
    <Tooltip content={t('expiredDelwins:delivery_window_expired_hint')}>
      <div>
        <WarningOutline className={cn('text-warning-48', className)} />
      </div>
    </Tooltip>
  );
};
